import React, { useState, useEffect } from 'react';
import { StatelessAccordion, Panel } from 'baseui/accordion';
import { useDependencies } from 'commons-ui';

interface AccordianPropsInterface {
	content: any;
	label: string;
	panelKey: string;
	watch: any;
}

const useAccordian = (props: AccordianPropsInterface) => {
	const { panelKey } = props;

	const [expanded, setExpanded] = useState<Array<React.ReactText>>([]);
	const { collapsibleDisabled } = useDependencies({ ...props, name: panelKey });

	useEffect(() => {
		if (collapsibleDisabled) {
			setExpanded([panelKey]);
		}
	}, [collapsibleDisabled]);

	return { expanded, setExpanded, collapsibleDisabled };
};

const Accordian: React.FC<AccordianPropsInterface> = (props) => {
	const { content, label, panelKey } = props;
	const { expanded, setExpanded, collapsibleDisabled } = useAccordian(props);

	return (
		<StatelessAccordion
			onChange={({ expanded: panelExpanded }) => {
				setExpanded(panelExpanded);
			}}
			expanded={expanded}
			disabled={collapsibleDisabled}>
			<Panel key={panelKey} title={label}>
				{content}
			</Panel>
		</StatelessAccordion>
	);
};

export default Accordian;
